export const hardwareTestSubmitDateFormat = 'yyyy-MM-dd'
export const OWNER_CHANGE_MIN_DATE = '2000-01-01'
